import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { cachedGet } from '../lib/api';
import RecipeCard from '../components/RecipeCard';

export default function Trending() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cachedGet('/recipes/trending').then(({ data }) => {
      setItems(data);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="trending-page">
      <header className="flex items-center gap-3">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E29F48] text-white">
          <Flame className="h-6 w-6" />
        </span>
        <div>
          <h1 className="text-3xl sm:text-4xl font-display font-bold tracking-tight">{t('trending')}</h1>
          <p className="text-sm text-[#5C4D44] dark:text-neutral-400">{t('trendingHint')}</p>
        </div>
      </header>

      {loading ? (
        <p className="text-center text-[#5C4D44] dark:text-neutral-400 py-12">...</p>
      ) : items.length === 0 ? (
        <p className="text-center text-[#5C4D44] dark:text-neutral-400 py-12">{t('noTrending')}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="trending-list">
          {items.map((row, i) => (
            <div key={`${row.recipe.recipe_id}-${i}`} className="relative">
              <RecipeCard recipe={row.recipe} index={i} />
              <span className="absolute top-3 start-3 z-10 bg-[#E29F48] text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md inline-flex items-center gap-1">
                <Flame className="h-3 w-3" /> {row.views}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
